hmi.models.point_matrix = function () {
  "use strict";

  //============================================================
  // Public Variables with Default Settings
  //------------------------------------------------------------
  var sizeComponent = 1.5 * 40;
  var scale = 1;

  //============================================================
  // Private Variables
  //------------------------------------------------------------
  var dispatch = d3.dispatch("click");

  function point_matrix(selection) {
    selection.each(function (data) {
      var container = d3.select(this);
      var xSteps = data[0];
      var ySteps = data[1];
      var xStepsData = xSteps[1];
      var yStepsData = ySteps[1];
      xStepsData.push(xStepsData[xStepsData.length - 1] + sizeComponent);
      yStepsData.push(yStepsData[yStepsData.length - 1] + sizeComponent);
      var xExtend = xStepsData[xStepsData.length - 1];
      var yExtend = yStepsData[yStepsData.length - 1];
      xStepsData.forEach(function (x) {
        yStepsData.forEach(function (y) {
          container
            .append("circle")
            .style("fill", "#505050")
            .style("opacity", "1")
            .attr("cx", x + sizeComponent / 2)
            .attr("cy", y + sizeComponent / 2)
            .attr("r", 2)
            .on("click", function (event) {
              var temp = d3.mouse(this);
              console.log("test");
              dispatch.click(this);
            });
        });
      });

      /* xStepsData.forEach(function (x) {
                container.append('line')
                    .style("stroke", "#d0d0d0")
                    .style('opacity', '1')
                    .attr('x1', x)
                    .attr('y1', ySteps[0][0] - sizeComponent)
                    .attr('x2', x)
                    .attr('y2', yExtend - sizeComponent);
            });
            yStepsData.forEach(function (y) {
                container.append('line')
                    .style("stroke", "#d0d0d0")
                    .style('opacity', '1')
                    .attr('x1', xSteps[0][0])
                    .attr('y1', y - sizeComponent)
                    .attr('x2', xExtend)
                    .attr('y2', y - sizeComponent);
            }); */
    });

    return point_matrix;
  }

  point_matrix.dispatch = dispatch;
  point_matrix.sizeComponent = sizeComponent;
  point_matrix.scale = scale;

  point_matrix._options = Object.create(
    {},
    {
      // simple options, just get/set the necessary values
      sizeComponent: {
        get: function () {
          return sizeComponent;
        },
        set: function (_) {
          sizeComponent = _;
        }
      },
      scale: {
        get: function () {
          return scale;
        },
        set: function (_) {
          scale = _;
        }
      }
    }
  );

  hmi.utils.initOptions(point_matrix);

  return point_matrix;
};
